<template>
  <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
        <form>
          <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openAddDialog" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
          <Dialogs  header="Clinet Details"  :visible.sync="addDisplayBasic" :style="{width: '50vw'}"
          :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <label for="name" >Name<span style="color:red">*</span></label>
                <InputText id="name" v-model.trim="clientName" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="address" >Address<span style="color:red">*</span></label>
                <InputText id="address" v-model.trim="address" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="primaryContactNumber" >Contact Number</label>
                <InputText @keypress="isNumber($event)" v-model="primaryContactNumber" id="primaryContactNumber"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="sec">Secondary Contact Number</label>
                <InputText  v-model.trim="secondaryContactNumber" id="sec"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="email" >Email</label>
                <InputText v-model.trim="email" id="email" />
              </div>

             <div class="p-field p-col-12 p-md-6">
                <label for="status1" >Status</label>
                <div class="p-field p-col-12 p-md-6">
                  <RadioButton id="status1" name="ACTIVE" value="ACTIVE" v-model="status" />
                  <label for="status1">Active</label>
                  <RadioButton id="status2" name="INACTIVE" value="INACTIVE" v-model="status" />
                  <label for="status2">Inactive</label>
                </div>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="description">Description</label>
                <textarea type="text" rows="2" class="form-control" v-model="description"/>
              </div>

          <div class="p-field p-col-12 p-md-6">
              <Button class="p-button-raised" @click.prevent="openAddPersonalInfoDialog" label="Contact Person Details"/>
              </div>    
      </div>
      <template #footer>
        <Button class="p-button-raised" @click.prevent="addClient" :label="editing?'Update':'Add'"/>
        <Button  @click.prevent="addCancel" class="p-button-raised p-button-danger" label="Cancel"/>
      </template>
      </Dialogs>
      <Dialogs  header="Clinet Contact Details"  :visible.sync="addPersonalDisplayBasic" :style="{width: '50vw'}"
          :modal="true" :closable=true :contentStyle="{'overflow': 'visible'}">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <label for="contactName" >Name<span style="color:red">*</span></label>
                <InputText id="contactName" v-model.trim="contactName" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="address" >Address<span style="color:red">*</span></label>
                <InputText id="contactAddress" v-model.trim="contactAddress" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="contactPrimaryContactNumber" >Contact Number</label>
                <InputText @keypress="isNumber($event)" v-model="contactPrimaryContactNumber" id="contactPrimaryContactNumber"/>
              </div>
              <!-- <div class="p-field p-col-12 p-md-6">
                <label for="conSec">Secondary Contact Number</label>
                <InputText  v-model.trim="contactSecondaryContactNumber" id="conSec"/>
              </div> -->
              <div class="p-field p-col-12 p-md-6">
                <label for="contactEmail" >Email</label>
                <InputText v-model.trim="contactEmail" id="contactEmail" />
              </div>

               <div class="p-field p-col-12 p-md-6">
                <label for="designation" >Designation</label>
                <InputText v-model.trim="designationName" id="designationId" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="conDescription">Description</label>
                <textarea type="text" rows="2" id="conDescription" class="form-control" v-model="contactDescription"/>
              </div> 

      </div>
      <Button class="p-button-raised" @click.prevent="addPersonalInfoDetails" :label="editing?'Update':'Add'"/>
    

      <DataTable ref="po"
      :value="crmClientPersonalInfoDTOList"
      :paginator="true"
      :rows="8" :filters="filters"
      class="p-datatable-responsive p-datatable-gridlines"
    >
    <!-- <template #header>
        <div style="text-align: left">
            <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
        </div>
    </template> -->
      <Column header="S.n">
        <template #body="slotProps">
        {{slotProps.index+1}}
        </template>
      </Column>
      <Column :sortable="true"   header="Name" field="name" filterMatchMode="contains" >
         <template #filter>
           <InputText type="text" class="p-column-filter" v-model="filters['name']" />
         </template>
      </Column>
      <Column :sortable="true"
        header="Address"
        field="address"
        filterMatchMode="contains"
      >
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['address']" />
        </template>
      </Column>

    <Column :sortable="true" header="Contact Number" field="contactNumber" filterMatchMode="contains" >
     <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
        </template>
      </Column>

      <!-- <Column :sortable="true" header="Secondary Contact" field="secondaryContactNumber"
       filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['secondaryContactNumber']" />
        </template>
      </Column> -->
       <Column :sortable="true" header="Email" field="email" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['email']" />
        </template>
      </Column>
    <Column header="Action" headerStyle="width: 11em">
        <template #body="slotProps">
            <Button icon="pi pi-pencil" class="p-button-raised p-button-success" @click="editPersonalInfo(slotProps.data , slotProps.index)" />
            <Button icon="pi pi-trash" class="p-button-danger p-button-sm" @click="removePersonalInfo(slotProps.index)"/>
        </template>
      </Column>
      </DataTable>
      <template #footer>
       
        <!-- <Button  @click.prevent="cancelAddPersonalInfoDialog" class="p-button-raised p-button-danger" label="Cancel"/> -->
        <Button class="p-button-raised" @click.prevent="closePersonalDetailsDialog" label="Save"/>
      <Button  @click.prevent="cancelAddPersonalInfoDialog" class="p-button-raised p-button-danger" label="Cancel"/>
      </template>
     
      </Dialogs>
    </form>
  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import RadioButton from 'primevue/radiobutton'
import Dialogs from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Textarea from 'primevue/textarea'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
export default {
  name: 'supplier',
  data() {
    return {
      clientName: '',
      address: '',
      primaryContactNumber: '',
      secondaryContactNumber: '',
      email: '',
      description: '',
      contactName: '',
      contactAddress: '',
      contactPrimaryContactNumber: '',
      contactSecondaryContactNumber: '',
      contactEmail: '',
      designationId: '',
      contactDescription: '',
      designationName: '',
      dialogShow: false,
      addDisplayBasic: false,
      addPersonalDisplayBasic: false,
      addDialog: false,
      editing: false,
      status: 'ACTIVE',
      id: '',
      loading: false,
      editDto: false,
      columnList: '',
      filters: {},
      crmClientPersonalInfoDTOList: []
    }
  },
  methods: {
    async addClient() {
      if (this.clientName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.address === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'address cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        id: this.editing ? this.id : null,
        clientName: this.clientName,
        address: this.address,
        primaryContactNumber: this.primaryContactNumber,
        secondaryContactNumber: this.secondaryContactNumber,
        email: this.email,
        description: this.description,
        status: this.status,
        clientType: 'Client',
        crmClientPersonalInfoDTOList: this.crmClientPersonalInfoDTOList.map(item => {
          const newItem = {...item}
          if (!this.editing) {
            delete newItem.id
          }
          return newItem
        })
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createCrmClient', accountMaster)
        // this.$emit('set_supplier_master', resp.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateCrmClient', accountMaster)
        this.loading = false
      }
      this.responseMessage(resp)
      this.closeAddDialog()
    },
    async addAndNewClient() {
      if (this.clientName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.address === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'address cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        clientName: this.clientName,
        address: this.address,
        primaryContactNumber: this.primaryContactNumber,
        secondaryContactNumber: this.secondaryContactNumber,
        email: this.email,
        description: this.description,
        status: this.status,
        clientType: 'Client',
        crmClientPersonalInfoDTOList: this.crmClientPersonalInfoDTOList.map(item => {
          const newItem = {...item}
          if (!this.editing) {
            delete newItem.id
          }
          return newItem
        })
      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('createCrmClient', accountMaster)
      this.loading = false
      this.responseMessage(resp)
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
        this.editing = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    removePersonalInfo(index) {
      this.crmClientPersonalInfoDTOList.splice(index, 1)
    },
    addPersonalInfoDetails() {
      if (this.contactName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.contactAddress === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Address cannot be empty!', life: 10000})
        return
      }
      let item = {
        name: this.contactName,
        address: this.contactAddress,
        contactNumber: this.contactPrimaryContactNumber,
        secondaryContactNumber: this.contactSecondaryContactNumber,
        email: this.contactEmail,
        remarks: this.contactDescription,
        id: this.id || Date.now(),
        clientId: this.clientId,
        designationName: this.designationName
      }
      if (this.editDto && this.id) {
        item.id = this.id
      }
      if (!this.editDto) {
        item.tempId = 'temp_' + Date.now()
        this.crmClientPersonalInfoDTOList.push(item)
      } else {
        this.crmClientPersonalInfoDTOList.splice(this.index, 1, item)
      }
      this.resetPersonalInfo()
      this.editDto = false
      // this.addPersonalDisplayBasic = false
      // this.itemDTOreset()
      // this.focusInput()
    },
    closePersonalDetailsDialog() {
      this.addPersonalDisplayBasic = false
    },
    editClient(data) {
      this.id = data.id
      this.clientName = data.clientName
      this.address = data.address
      this.primaryContactNumber = data.primaryContactNumber
      this.secondaryContactNumber = data.secondaryContactNumber
      this.email = data.email
      this.status = data.status
      this.description = data.description
      this.crmClientPersonalInfoDTOList = Array.isArray(data.crmClientPersonalInfoDTOList)
        ? [...data.crmClientPersonalInfoDTOList]
        : []
      this.addDisplayBasic = true
      this.editing = true
      // this.openAddDialog()
    },
    editPersonalInfo(data, index) {
      // this.addPersonalDisplayBasic = false
      this.id = data.id
      this.contactName = data.name
      this.contactAddress = data.address
      this.contactPrimaryContactNumber = data.contactNumber
      this.contactSecondaryContactNumber = data.secondaryContactNumber
      this.contactEmail = data.email
      this.contactDescription = data.remarks
      this.designationName = data.designationName
      this.editDto = true
      this.index = index
    },
    edit(data) {
      this.addDisplayBasic = false
      this.id = data.id
      this.clientName = data.clientName
      this.address = data.address
      this.primaryContactNumber = data.primaryContactNumber
      this.secondaryContactNumber = data.secondaryContactNumber
      this.email = data.email
      this.description = data.description
      this.openAddDialog()
    },
    cancel() {
      this.dialogShow = false
    },
    resetPersonalInfo() {
      this.contactName = ''
      this.contactAddress = ''
      this.contactPrimaryContactNumber = ''
      this.contactSecondaryContactNumber = ''
      this.contactEmail = ''
      this.contactDescription = ''
      this.designationName = ''
      // this.crmClientPersonalInfoDTOList = []
    },
    reset() {
      this.name = ''
      this.address = ''
      this.primaryContactNumber = ''
      this.secondaryContactNumber = ''
      this.email = ''
      this.status = ''
      this.clientName = ''
      this.crmClientPersonalInfoDTOList = []
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    openAddPersonalInfoDialog() {
      this.addPersonalDisplayBasic = true
      this.editDto = false
      this.resetPersonalInfo()
    },
    cancelAddPersonalInfoDialog() {
      this.resetPersonalInfo()
      this.addPersonalDisplayBasic = false
    },
    openAddDialog() {
      this.addDisplayBasic = true
      this.editing = false
    },
    closeAddDialog() {
      this.addDisplayBasic = false
    },
    addCancel() {
      this.reset()
      this.resetPersonalInfo()
      this.closeAddDialog()
    }
  },
  components: {
    Dropdown,
    RadioButton,
    Dialogs,
    Button,
    InputText,
    InputMask,
    Textarea,
    DataTable,
    Column
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// crmClientDetailsDialog.vue?752ed746